import './HousePage.css';
import React, { useContext } from 'react';

import { RouteComponentProps, useParams } from 'react-router';

import { useNewsByHouse } from '../hooks/WPHooks';
import { HouseInfo, WP_HouseMainPage, HouseService } from '../model/models';
import _ from 'underscore';
import HouseCard from '../components/house/houseCard';
import { ServicesTab } from '../components/house/ServicesTab';
import { NewsTab } from '../components/house/NewsTab';
import { AboutTab } from '../components/house/AboutTab';
import { TabData, Tabs } from '../components/globals/Tabs';
import { AppPage } from '../AppContent';
import { AppContext } from '../state/AppContextProvider';
import { EventsTab } from '../components/house/EventsTab';
import { useEventsByHouse } from '../hooks/EventHook';

interface HousePageProps extends RouteComponentProps {}

const HousePage: React.FC<HousePageProps> = (props: HousePageProps) => {
  const { state } = useContext(AppContext);

  const { houseNews } = useNewsByHouse();

  const { houseEvents } = useEventsByHouse();

  const houseMainPage: WP_HouseMainPage = _.findWhere(state.housePages, {
    parent: 0,
  }) as WP_HouseMainPage;

  const houseServices: HouseService[] = state.housePages.filter(
    (p: HouseInfo) => p.parent && p.parent > 0
  ) as HouseService[];

  const { slug, slug1, slug2 }: any = useParams();

  const slugs: string[] = [slug, slug1, slug2].filter((s) => s);

  const tabs: TabData[] = [
    {
      label: 'About',
      link: '/house/about',
      component: <AboutTab houseMainPage={houseMainPage} />,
    },
    {
      label: 'Services',
      link: '/house/services',
      component: (
        <ServicesTab
          services={houseServices}
          slugs={slugs}
          houseMainPage={houseMainPage}
        />
      ),
    },
    {
      label: 'News',
      link: '/house/news',
      component: <NewsTab newsList={houseNews} />,
    },
    {
      label: 'Events',
      link: '/house/events',
      component: <EventsTab eventsList={houseEvents} />,
    },
  ];

  return (
    <AppPage scrollable={true}>
      <div className="px-4 md:px-14">
        {houseMainPage && <HouseCard houseMainPage={houseMainPage} />}
      </div>
      <Tabs id="house-tabs" tabs={tabs} classT="md:hidden" {...props} />
    </AppPage>
  );
};

export default HousePage;
